<template>
    <div class="dvBgiBox">
        <div style="padding: 10px;">
            <p style="font-size: 22px;font-weight: 600;text-align: left;color: #fff;">{{ $t('cumulative.title') }}</p>
        </div>

        <div style="width: 100%;padding: 0px 20px;margin: 30px 0px;">
            <div class="itemRow">
                <div class="item">
                    <img src="../../assets/left03-1.png" style="width: 70px;height: 60px;" alt="">
                    <span style="margin-left: 15px;" class="txt">{{ $t('cumulative.gridConsumption') }}</span>
                </div>
                <div class="txt" style="display: flex;flex-direction: column;align-items: center;">
                    <span>{{ totalEcele_month }}</span>
                </div>
            </div>

            <div class="itemRow">
                <div class="item">
                    <img src="../../assets/left03-1.png" style="width: 70px;height: 60px;" alt="">
                    <span style="margin-left: 15px;" class="txt">{{ $t('cumulative.storageConsumption') }}</span>
                </div>
                <div class="txt" style="display: flex;flex-direction: column;align-items: center;">
                    <span>{{ batEcele_month }}</span>
                </div>
            </div>

            <div class="itemRow">
                <div class="item">
                    <img src="../../assets/left03-1.png" style="width: 70px;height: 60px;" alt="">
                    <span style="margin-left: 15px;" class="txt">{{ $t('cumulative.pvGeneration') }}</span>
                </div>
                <div class="txt" style="display: flex;flex-direction: column;align-items: center;">
                    <span>{{ sun_charge_Power_month }}</span>
                </div>
            </div>

        </div>


    </div>
</template>

<script>

export default {
    data() {
        return {

        };
    },
    props: {
        totalEcele_month: {
            default: ''
        },
        batEcele_month: {
            default: ''
        },
        sun_charge_Power_month: {
            default: ''
        },
    },
    watch: {

    },

    methods: {


    }

}
</script>

<style scoped>
.dvBgiBox {
    width: 100%;
    padding: 5px 10px 10px 10px;
    background-image: url("../../assets/dvBgiBoxleft.png");
    background-size: 100% 100%;
    margin-bottom: 20px;
}

.itemRow {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    box-shadow: 0 1px 6px -1px rgba(68, 254, 217, 0.8);
    padding: 12px;
}

.item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.txt {
    font-size: 21px;
    color: #adf1ff;
}
</style>